export const DAYS_LIST = [
    { day: 'Monday', label: 'Mon' },
    { day: 'Tuesday', label: 'Tue' },
    { day: 'Wednesday', label: 'Wed' },
    { day: 'Thursday', label: 'Thu' },
    { day: 'Friday', label: 'Fri' },
    { day: 'Saturday', label: 'Sat' },
    { day: 'Sunday', label: 'Sun' },
];
